import { logger } from '../../logger';

export type LmaHttpMethod = 'GET' | 'POST' | 'PUT' | 'DELETE';

export interface LmaSafeLogOptions {
  operation: string;
  method: LmaHttpMethod;
  endpoint: string;
  extra?: Record<string, unknown>;
}

export const withLmaSafeApiLogging = async <T>(
  options: LmaSafeLogOptions,
  action: () => Promise<T>
): Promise<T> => {
  const start = Date.now();
  const thresholdMs = Number(process.env.NEXT_PUBLIC_LMA_SLOW_API_THRESHOLD_MS) || 15000;

  try {
    const result = await action();
    const duration = Date.now() - start;
    if (duration > thresholdMs) {
      const warningMessage = `LMA Alert Warning: ${options.operation} exceeded ${thresholdMs}ms`;
      const warningPayload = {
        endpoint: options.endpoint,
        method: options.method,
        duration,
        ...(options.extra || {}),
      };

      logger.warn(warningMessage, warningPayload);
    }

    return result;
  } catch (error: any) {
    const duration = Date.now() - start;

    const errorMessage = `LMA Alert Error: ${options.operation} failed`;
    const errorPayload = {
      endpoint: options.endpoint,
      method: options.method,
      duration,
      error: error?.message || error?.response?.data?.message || 'Unknown error',
      ...(options.extra || {}),
    };

    logger.error(errorMessage, errorPayload);

    throw error;
  }
};
